module.exports = __webpack_public_path__ + "img/about-2-company.183d963b.png";